
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import mentee from "../../assets/new images/mentee.png";
import backgroundImage from "../../assets/new images/findmentor.png";
import TeamBioSection from "../../components/root/TeamBioSection";
import AboutCabil from "../../components/root/AboutCabil";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
const FindMentor = () => {
  const { t } = useTranslation();
  return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/find-mentor"]}
        path="/find-mentor"
      />

      <Hero bgImage={backgroundImage}
        badgeText={`✨ ${t("hero.badge")}`}
        titleLines={[t("findMentor.heroTitle1"), t("findMentor.heroTitle2")]}
        subtitle={t("findMentor.heroSubtitle")}
        primary={{ label: t("hero.findMentor"), href: "/mentors" }}
        secondary={{ label: t("hero.tryAi"), href: "/ai-career" }}
        curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
        heightClass="h-[100vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

     <TeamBioSection
  heading={t("findMentor.teamHeading")}
  body={[t("findMentor.teamBody1"), t("findMentor.teamBody2")]}
  img={mentee}
  showDot={false}                 // hide the name dot
  showCorners={true}              // keep the corner pills
  reverse={false}                 // image on the left (like your screenshot)
  cta={{ label: t("hero.findMentor"), href: "/become-a-mentor" }}
/>


    </div>
  );
};

export default FindMentor;
